document.addEventListener("DOMContentLoaded", function () {
  let isLoading = false;

  window.addEventListener("scroll", function () {
    const scrollTrigger = 400;

    const scrollPercentage = (window.scrollY + window.innerHeight) / document.body.offsetHeight; 
    if (!isLoading && scrollPercentage >= 0.70) {
      const nextLink = document.querySelector("#pagination a[rel='next']");

      if (nextLink) {
        isLoading = true;

        const loader = document.querySelector(".svg-loader-container");
        if (loader) loader.style.display = "block";

        fetch(nextLink.href)
          .then(response => {
            return response.text();
          })
          .then(data => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data, 'text/html');

            const newProducts = html.querySelectorAll("#product-grid > div");
            const productGrid = document.querySelector("#product-grid");

            if (!productGrid) {
              console.error("Conteneur #product-grid introuvable !");
              return;
            }

            if (newProducts.length === 0) {
              console.warn("Aucun nouveau produit trouvé !");
            }

            newProducts.forEach(el => productGrid.appendChild(el));

            const newPagination = html.querySelector("#pagination");
            if (newPagination) {
              document.querySelector("#pagination").innerHTML = newPagination.innerHTML;
            } else {
              console.warn("Pagination suivante non trouvée.");
            }

            if (loader) loader.style.display = "none";
            isLoading = false;
          })
          .catch(err => {
            console.error("Erreur scroll infini:", err);
            if (loader) loader.style.display = "none";
            isLoading = false;
          });
      }
    }
  });
});
